import { jsx as _jsx } from "react/jsx-runtime";
/**
 * 菜单分隔符
 */
import Menu from 'antd/es/menu';
import styled from 'styled-components';
export const DividerMenuItem = () => (_jsx(DividerWrapper, { children: _jsx(Menu.Divider, { style: {
            // full 模式下需要借用 absolute 使其超出父容器宽度
            position: 'absolute',
            width: '100%',
            left: 0,
        } }, void 0) }, void 0));
const DividerWrapper = styled.div `
  &&& {
    // menu左右有12的内边距, 所以需要加24
    width: calc(100% + 24px);
    left: -12px;

    position: relative;
    display: flex;
    align-items: center;
    margin: 16px 0;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGl2aWRlck1lbnVJdGVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL0FwcExheW91dC9jb21wb25lbnRzL0RpdmlkZXJNZW51SXRlbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOztHQUVHO0FBQ0gsT0FBTyxJQUFJLE1BQU0sY0FBYyxDQUFBO0FBQy9CLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFBO0FBRXRDLE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBRyxHQUFHLEVBQUUsQ0FBQyxDQUNuQyxLQUFDLGNBQWMsY0FDYixLQUFDLElBQUksQ0FBQyxPQUFPLElBQ1gsS0FBSyxFQUFFO1lBQ0wsa0NBQWtDO1lBQ2xDLFFBQVEsRUFBRSxVQUFVO1lBQ3BCLEtBQUssRUFBRSxNQUFNO1lBQ2IsSUFBSSxFQUFFLENBQUM7U0FDUixXQUNELFdBQ2EsQ0FDbEIsQ0FBQTtBQUVELE1BQU0sY0FBYyxHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUE7Ozs7Ozs7Ozs7O0NBV2hDLENBQUEifQ==